<template>
  <div :class="{'saved-searches-open': showSavedSearches}">
    <p v-if="$route.query.no_cache" class="text-danger text-center">NO CACHE</p>
    <SearchPopup :search="search" :save-search="saveFilters" :filters="filters" :saveMessage="localSaveMessage"
                 @update:saveMessage="localSaveMessage = $event" :clearData="clearData" ref="popup"/>
    <SearchPopup :search="resetFilters" :save-search="saveFilters" :filters="filters" :saveMessage="localSaveMessage"
                 @update:saveMessage="localSaveMessage = $event" ref="reset-popup"/>
    <div class="search-filters-header">
      <div class="header-title">
        {{currentSearchIsMetricBased ? 'Advanced Analytics' : 'Study Search'}}
      </div>
      <span class="warning-text" v-if="this.$refs.metricsForm && !this.metricsAreFilled">You need to select at least one metric!</span>
      <div class="header-subtitle">
        {{getHeaderText()}}
      </div>
      <div class="filter-tabs-wrapper">
        <template v-if="currentSearchIsMetricBased">
          <div class="filters-tab" :class="{selected: openedPanel === 'Metrics'}" @click="[openedPanel = 'Metrics', $emit('setCollapse', true)]">
            METRICS
          </div>
          <div class="filters-tab" :class="{selected: openedPanel === 'Demographics'}"
               @click="[openedPanel = 'Demographics', $emit('setCollapse', true)]">
            DEMOGRAPHICS
          </div>
        </template>
        <div class="filters-tab" :class="{selected: openedPanel === 'Essentials'}" @click="[openedPanel = 'Essentials', $emit('setCollapse', true)]">
          ESSENTIALS
        </div>
        <div class="filters-tab" :class="{selected: openedPanel === 'Fragrance Details'}"
             @click="[openedPanel = 'Fragrance Details', $emit('setCollapse', true)]">FRAGRANCE DETAILS
        </div>
        <div class="filters-tab" :class="{selected: openedPanel === 'Concept Details'}"
             v-if="userPermissions.isAdmin"
             @click="[openedPanel = 'Concept Details', $emit('setCollapse', true)]">CONCEPT DETAILS
        </div>
        <div class="filters-tab" :class="{selected: openedPanel === 'Methodology'}" style="border-right: 0;"
             @click="[openedPanel = 'Methodology', $emit('setCollapse', true)]">METHODOLOGY
        </div>
        <div class="filters-tab saved-searches-toggle" @click="toggleSavedSearches()" :style="{right: showSavedSearches ? '348px' : '0'}">
          <font-awesome-icon style="font-size: 32px; margin-left: 2px;" icon="cloud" color="white"></font-awesome-icon>
        </div>
      </div>
    </div>
    <div class="card search-filters-card">
      <div class="open-filter-button" @click="toggleFiltersCollapse">
        <font-awesome-icon :icon="!collapsed ? 'expand' : 'compress'"/>
      </div>
      <div class="card-body search-filters-card-body">
        <b-collapse
            class="w-100"
            id="collapse-2"
            :visible="collapsed"
            @input="$emit('setCollapse', $event)"
        >
          <div v-if="openedPanel === 'Essentials'" class="form-container" :class="isIE ? 'visible-ie' : 'visible'"
               id="essentials"
               ref="essentials-container">
            <EssentialsForm ref="essentials" :filters="filters" @update:filters="filters = $event"
                            :updateDropdownValues="updateDropdowns" :getAPACcounts="getAPACcounts"
                            :get-metadata-tag-values="getMetadataTagValues" :year-input="localYearsObject"
                            @update:yearInput="localYearsObject = $event"></EssentialsForm>
          </div>
          <div v-if="openedPanel === 'Fragrance Details'" class="form-container"
               :class="isIE ? 'visible-ie' : 'visible'"
               id="fragrance-details"
               ref="fragrance-container">
            <FragranceDetailsForm :filters="filters" @update:filters="filters = $event" :updateDropdownValues="updateDropdowns"
                                  :getBenchmarkCreativeCount="getBenchmarkCreativeCount"
                                  :get-metadata-tag-values="getMetadataTagValues" :getAPACcounts="getAPACcounts"
                                  :get-fragrance-tag-values="getFragranceTagValues"></FragranceDetailsForm>
          </div>
          <div v-if="openedPanel === 'Concept Details'" class="form-container"
               :class="isIE ? 'visible-ie' : 'visible'"
               id="concept-details"
               ref="fragrance-container">
            <ConceptDetailsForm :filters="filters" @update:filters="filters = $event" :updateDropdownValues="updateDropdowns"
                                  :get-metadata-tag-values="getMetadataTagValues" :getAPACcounts="getAPACcounts"
                                  :get-concept-tag-values="getConceptTagValues"></ConceptDetailsForm>
          </div>
          <div v-if="openedPanel === 'Methodology' " class="form-container" :class="isIE ? 'visible-ie' : 'visible'"
               id="methodology"
               ref="methodology-container">
            <MethodologyForm :filters="filters" @update:filters="filters = $event" :updateDropdownValues="updateDropdowns"
                             :get-metadata-tag-values="getMetadataTagValues"></MethodologyForm>
          </div>
          <template v-if="currentSearchIsMetricBased">
            <div v-if="openedPanel === 'Demographics'" class="form-container" :class="isIE ? 'visible-ie' : 'visible'"
                 id="demographics"
                 ref="demographics-container">
              <DemographicsForm :filters="filters" @update:filters="filters = $event"
                                :updateDropdownValues="updateDropdowns"
                                :get-demographics-tag-values="getMetricsTagValues"
                                ref="demographicsForm"></DemographicsForm>
            </div>
            <div v-if="openedPanel === 'Metrics'" class="form-container" :class="isIE ? 'visible-ie' : 'visible'"
                 id="metrics"
                 ref="metrics-container">
              <MetricsForm :filters="filters" @update:filters="filters = $event"
                           :get-metrics-tag-values="getMetricsTagValues"
                           :updateDropdownValues="updateDropdowns"
                           :removeAppliedFilter="removeAppliedFilter"
                           v-on:add-metric="addMetric()"
                           v-on:refresh-options="switchSearchTypes"
                           v-on:remove-metric="removeMetric($event)"
                           :metricsAreFilled="metricsAreFilled"
                           ref="metricsForm"></MetricsForm>
            </div>
          </template>
        </b-collapse>
        <div class="row w-100">
          <div class="col-6 tag-wrapper">
            <CurrentTags :show="!areFiltersEmpty" :remove-applied-filter="removeAppliedFilter" :remove-metric="removeMetric"
                         :filters="filters"></CurrentTags>
          </div>
          <div class="col-6 search-filters-actions-wrapper">
            <div class="d-flex justify-content-between w-100" style="margin-bottom: 20px;">
              <el-input v-model="searchName" :class="{'is-invalid': localSaveMessage.error}"
                        style="height: 40px;" placeholder="Enter search name" clearable
                        @input="resetSaveMessage">
                <template #append>
                  <div :class="{'disabled-save': areFiltersEmpty}"
                       @click.prevent="() => {!areFiltersEmpty && saveFilters(searchName, filters)}"><font-awesome-icon style="font-size: 37px; margin: 0 5px;" icon="cloud-upload-alt" color="white"></font-awesome-icon> </div>
                </template>
              </el-input>
              <span v-if="localSaveMessage.error" class="error-message">{{localSaveMessage.value}}</span>
              <span v-if="!localSaveMessage.error && localSaveMessage.value" class="success-message">{{localSaveMessage.value}}</span>
            </div>
            <div class="d-flex justify-content-end align-items-center w-100">
              <div v-if="currentSearchIsMetricBased"
                      style="height: 40px; width: 40px; margin-right: 30px; cursor: pointer;"
                      @click="toggleDiagnostics()">
                <font-awesome-icon icon="info-circle" style="font-size: 40px; line-height: 40px; color: #202124;"></font-awesome-icon>
              </div>
              <button v-if="!currentSearchIsMetricBased && (userPermissions.isAdmin || userPermissions.canAccessAnalytics)"
                      class="search-button-alt btn"
                      type="button"
                      @click="goToAnalytics">
                Analytics
              </button>
              <button v-if="searchStarted" class="search-button-alt btn" type="button"
                      @click="() => $refs['reset-popup'].showPopup()">
                New search
              </button>
              <button class="search-button btn" type="button"
                      :disabled="this.$refs.metricsForm && (!this.$refs.metricsForm.metricsAreFilled || !this.$refs.metricsForm.thresholdCorrect)"
                      @click="search()">Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import studiesGetters from '../../store/modules/studies/getterTypes'
import studiesActions from '../../store/modules/studies/actionTypes'
import _ from 'lodash'
import EssentialsForm from './Forms/EssentialsForm'
import FragranceDetailsForm from './Forms/FragranceDetailsForm'
import ConceptDetailsForm from './Forms/ConceptDetailsForm'
import MethodologyForm from './Forms/MethodologyForm'
import DemographicsForm from './Forms/DemographicsForm'
import MetricsForm from './Forms/MetricsForm'
import filtersFunctions from '../../constants/searchFilters'
import yearBounds from '../../helpers/yearBounds'
import SearchPopup from './SearchPopup'
import tooltips from '../../constants/tooltips'
import CurrentTags from '../shared/CurrentTags'
import generalGetters from '../../store/modules/general/getterTypes'
import generalActions from '../../store/modules/general/actionTypes'
import globalAlertMixin from '@/mixins/globalAlert'

const lockedCmiToolTypes = [
  'Attitude and Usage (A&U)',
  'Benchmarking',
  'Central Location Test (CLT)',
  'Concept Scan',
  'Crowdsourcing (Crowdtap/Quick Survey)',
  'Global Testing Platform',
  'Home Use Test (HUT)',
  'Desk Research',
  'Internal Panel',
  'Qualitative Tools',
  'Sensory 1',
  'Sensory 2',
  'Social Listening',
  'SymArt Panel',
  'SymScan',
  'gen-isys'
]

export default {
  name: 'SearchFilters',
  emits: ['update:saveMessage', 'update:yearsObject', 'setCollapse'],
  components: {
    CurrentTags,
    SearchPopup,
    MetricsForm,
    DemographicsForm,
    MethodologyForm,
    FragranceDetailsForm,
    ConceptDetailsForm,
    EssentialsForm
  },
  mixins: [globalAlertMixin],
  props: {
    fields: Array,
    analyticsFields: Array,
    parseData: Function,
    updateDropdownValues: Function,
    toggleDiagnostics: Function,
    saveFilters: Function,
    switchTabs: Function,
    resetAnalyticsTabs: Function,
    resetDropdowns: Function,
    toggleSavedSearches: Function,
    showSavedSearches: Boolean,
    hideTabs: Function,
    saveMessage: Object,
    searchData: Function,
    collapsed: Boolean,
    header: {
      type: String,
      required: false
    },
    yearsObject: Object
  },
  data () {
    // eslint-disable-next-line
    const isIE = /*@cc_on!@*/false || !!document.documentMode
    const initialOpenedPanel = this.$route.name === 'analytics' ? 'Metrics' : 'Essentials'
    return {
      openedPanel: initialOpenedPanel,
      filters: {},
      previousRegionValues: [],
      searchName: '',
      isReady: false,
      searchStarted: false,
      isIE,
      tooltips,
      localSaveMessage: _.cloneDeep(this.saveMessage),
      localYearsObject: this.yearsObject ? _.cloneDeep(this.yearsObject) : this.yearsObject
    }
  },
  computed: {
    ...mapGetters({
      filterValues: studiesGetters.GET_SEARCH_FILTERS,
      userPermissions: generalGetters.GET_PERMISSIONS
    }),
    tagsList () {
      const { essentials, fragranceDetails, methodology, metrics, demographics } = this.filters
      return this.currentSearchIsMetricBased
        ? { ...essentials, ...methodology, ...metrics, ...demographics, ...fragranceDetails }
        : { ...essentials, ...fragranceDetails, ...methodology }
    },
    currentSearchIsMetricBased () {
      return ['analytics', 'cics'].includes(this.$route.name)
    },
    areFiltersEmpty () {
      const data = this.parseData(_.cloneDeep(this.filters), this.currentSearchIsMetricBased)
      const unpackedData = []
      Object.values(data).forEach(el => {
        if (Array.isArray(el) && el.length) {
          if (el[0].field !== 'concepts') {
            unpackedData.push(el)
          }
        } else if (typeof el !== 'string' && ((el && el.value) || (el && el.length)) && el.field !== 'verified') {
          unpackedData.push(el)
        } else if (el.field === 'verified' && this.userPermissions.isAdmin) {
          unpackedData.push(el)
        }
      })
      return !unpackedData.length
    },
    metricsAreFilled () {
      return !this.filters.metrics.metricsList.find(el => !el.metricType.value || !el.metric.value || !el.aggregation.value)
    }
  },
  methods: {
    ...mapActions({
      updateStoreFilters: studiesActions.SET_OR_CLEAR_SEARCH_FILTERS,
      clearAnalytics: studiesActions.CLEAR_ANALYTICS,
      clearSummaries: studiesActions.CLEAR_STUDY_SUMMARIES,
      clearFragrances: studiesActions.CLEAR_FRAGRANCES,
      clearConcepts: studiesActions.CLEAR_CONCEPTS,
      clearFiles: studiesActions.CLEAR_FILES,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    showAlert (title, message, type = 'error') {
      const options = {
        duration: 5000,
        title: title,
        message: message,
        type: type
      }
      this.launchAlert(options)
    },
    resetSaveMessage () {
      this.localSaveMessage = {
        ...this.localSaveMessage,
        error: false,
        value: ''
      }
    },
    getMetadataTagValues (tag) {
      if (this.fields.length) {
        const tags = this.fields[0].data.find(el => el.field === tag)
        if (!tags) return []
        if (tag === 'cmi_tool_type') {
          const allowedValues = new Set(lockedCmiToolTypes)
          return tags.options
            .filter(opt => allowedValues.has(opt.value))
            .sort((a, b) => lockedCmiToolTypes.indexOf(a.value) - lockedCmiToolTypes.indexOf(b.value))
        }
        return tags.options
      }
      return []
    },
    getFragranceTagValues (tag) {
      if (this.fields.length) {
        const tags = this.fields[1].data.find(el => el.field === tag)
        return tags ? tags.options : []
      }
      return []
    },
    getConceptTagValues (tag) {
      if (this.fields.length) {
        const tags = this.fields[1].data.find(el => el.field === tag)
        return tags ? tags.options : []
      }
      return []
    },
    getDemographicsTagValues (tag) {
      if (this.analyticsFields.demographics && Object.keys(this.analyticsFields.demographics).length) {
        return this.analyticsFields.demographics[tag] || []
      }
      return []
    },
    getMetricsTagValues (tag) {
      switch (tag) {
        case 'metrics':
          return this.analyticsFields.find(el => el.group_label === 'metrics').data
        case 'stage':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.stage
        case 'order':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.order
        case 'aggregations':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.aggregations
        case 'threshold':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.threshold
        case 'bumo':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.demographics.bumo
        case 'gender':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.demographics.gender
        case 'social_class':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.demographics.social_class
        case 'ethnicity':
          return this.analyticsFields.find(el => el.group_label === 'aggregation').data.demographics.ethnicity
        default:
          return []
      }
    },
    getAPACcounts (tag = 'metadata') {
      if (this.fields.length) {
        const fieldList = this.fields.find(el => el.group_label === tag)
        if (fieldList) {
          const tags = fieldList.data.find(el => el.field === 'region')
          if (tags) {
            const filteredValues = tags.options.filter(el => ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(el.value))
            const counts = filteredValues.map(el => el.count)
            const count = counts.reduce((a, b) => {
              return a + b
            }, 0)
            const aspacObj = { value: 'APAC', count }
            filteredValues.push(aspacObj)
            return filteredValues.sort((a, b) => {
              return a.value > b.value ? 1 : a.value < b.value ? -1 : 0
            })
          }
        }
      }
      return []
    },
    getBenchmarkCreativeCount (value) {
      if (this.fields.length) {
        const fieldList = this.fields.find(el => el.group_label === 'fragrance')
        if (fieldList) {
          let benchCreateData = fieldList.data.filter(obj => obj.field === 'bench_create')
          if (benchCreateData && benchCreateData.length) {
            const valueObj = benchCreateData[0].options.filter(obj => obj.value === value)
            if (valueObj && valueObj.length) {
              return valueObj[0].count
            }
          }
        }
      }
      return 0
    },
    isArray (value) {
      return Array.isArray(value)
    },
    clearData () {
      this.hideTabs()
      this.clearAnalytics()
      this.clearSummaries()
      this.clearFragrances()
      this.clearConcepts()
      this.clearFiles()
    },
    clearName () {
      this.searchName = ''
    },
    async resetFilters (skipDropdowns = false) {
      await this.updateStoreFilters({ clearFilters: true, filters: null })
      this.refreshFilters()
      this.clearData()
      if (!skipDropdowns) {
        this.resetDropdowns()
      }
      this.$emit('setCollapse', true)
    },
    parseMetricName (value, type) {
      let data = value.split('_')
      if (type !== 'Performance') {
        data.splice(data.length - 1, 1)
      }
      return data.join(' ')
    },
    // Deep link support: pre-fill filters from a URL query so another system
    // can link straight into a search (e.g. /search?pace_number=...). Returns
    // { applied, ignored } so the caller can report unrecognised params.
    async applyQueryFilters (query) {
      const filters = _.cloneDeep(this.filters)
      const result = filtersFunctions.applyQueryToFilters(filters, query)
      if (result.applied.length) {
        this.filters = filters
        await this.updateStoreFilters({
          clearFilters: false, filters: _.cloneDeep(filters)
        })
      }
      return result
    },
    refreshFilters (appliedSavedSearch = false) {
      this.filters = _.cloneDeep({ ...this.filters, ...this.filterValues })
      if (appliedSavedSearch) {
        this.filters = _.cloneDeep(this.filterValues)
      }
      this.removeAppliedFilter({ key: 'age' })
      this.removeAppliedFilter({ key: 'socialClass' })
      this.removeAppliedFilter({ key: 'threshold' })
    },
    togglePopup (url) {
      this.$refs.popup.showPopup(url)
    },
    async updateDropdowns (data) {
      await this.updateDropdownValues(_.cloneDeep(data || this.filters))
    },
    // Applying a saved search calls this to put the stored range back on the
    // slider. It was never defined, so Analytics and Search both threw here and
    // the rest of applyQuery never ran.
    applyYears (years) {
      if (!Array.isArray(years) || !this.localYearsObject) {
        return
      }
      const [from, to] = years
      if (from == null && to == null) {
        return
      }
      const { min, max } = this.localYearsObject
      this.localYearsObject = {
        ...this.localYearsObject,
        value: yearBounds.resolveYearSelection({
          previous: [Number(from ?? min), Number(to ?? max)],
          min,
          max
        })
      }
    },
    async switchSearchTypes (value, valueType) {
      this.toggleLoading(true)
      await this.resetFilters(true)
      const data = _.cloneDeep(this.filters)
      data.metrics[valueType] = value
      this.setFilterValue(value, valueType)
      await this.updateStoreFilters({ clearFilters: false, filters: data })
      await this.updateDropdowns(data)
      this.toggleLoading(false)
    },
    async search () {
      this.searchStarted = true
      if (this.currentSearchIsMetricBased) {
        if (this.metricsAreFilled) {
          this.$emit('setCollapse', false)
          this.updateStoreFilters({ clearFilters: false, filters: _.cloneDeep(this.filters) })
          this.clearData()
          this.resetAnalyticsTabs()
          this.searchData(this.parseData(this.filters, this.currentSearchIsMetricBased), null, 'metrics')
          this.switchTabs('metrics')
        } else {
          this.showAlert('Not all metrics were filled properly', '')
        }
      } else {
        this.$emit('setCollapse', false)
        this.updateStoreFilters({ clearFilters: false, filters: _.cloneDeep(this.filters) })
        this.clearData()
        this.searchData(this.parseData(this.filters, this.currentSearchIsMetricBased), {
          file_type: '',
          search_phrase: ''
        })
      }
    },
    applySocialClass (data) {
      const socialClassForm = this.$refs.demographicsForm
      if (socialClassForm) {
        socialClassForm.setSocialClass(data)
      }
    },
    goToAnalytics () {
      this.updateStoreFilters({ clearFilters: false, filters: _.cloneDeep(this.filters) })
      this.$router.push({ name: 'analytics', query: { allowLocationChange: '1' } })
    },
    getHeaderText () {
      return this.header || !this.currentSearchIsMetricBased ? 'What are you looking for today? Select the appropriate tab to specify search criteria.' : 'What would you like to analyze?'
    },
    removeAppliedFilter (tag, flags = {}) {
      const key = tag?.key
      const idx = Number.isInteger(tag?.idx) ? tag.idx : undefined

      const getByPath = (obj, path) => {
        const parts = Array.isArray(path) ? path : String(path).split('.')
        return parts.reduce((acc, k) => (acc && acc[k] != null ? acc[k] : undefined), obj)
      }
      const setValueEmptyReactive = (target, empty = '') => {
        if (!target) return
        if (Object.prototype.hasOwnProperty.call(target, 'value')) {
          const v = target.value
          if (Array.isArray(v)) this.$set(target, 'value', [])
          else if (typeof v === 'boolean') this.$set(target, 'value', false)
          else if (v && typeof v === 'object') this.$set(target, 'value', {})
          else this.$set(target, 'value', empty)
        }
      }
      const resetMetricRowField = (rowIndex, labelOrField = null) => {
        const list = this.filters?.metrics?.metricsList
        if (!list || !list[rowIndex]) return
        const m = list[rowIndex]

        const labelToKey = {
          'Metric type': 'metricType',
          'Metric': 'metric',
          'Aggregation': 'aggregation',
          'Confidence': 'confidence',
          'Threshold on metrics': 'threshold'
        }
        const fieldKey = labelToKey[labelOrField] || null

        if (!fieldKey) {
          this.$set(this.filters.metrics.metricsList, rowIndex, this.$options.filtersFunctions?.getEmptyMetric?.() || require('../../constants/searchFilters').default.getEmptyMetric())
          return
        }

        if (fieldKey === 'confidence') {
          this.$set(m.confidence, 'value', false)
          return
        }

        if (fieldKey === 'threshold') {
          this.$set(m, 'applyThreshold', false)
          if (m.threshold?.value) {
            this.$set(m.threshold, 'value', { amount: 10, desc: false, type: '' })
          }
          return
        }
        if (m[fieldKey]) setValueEmptyReactive(m[fieldKey], '')
      }
      if (key === 'metrics.metricsList' && idx !== undefined) {
        resetMetricRowField(idx, tag.label)
        return
      }
      if (key === 'metrics.threshold') {
        const mt = this.filters && this.filters.metrics && this.filters.metrics.threshold
        if (mt) this.$set(mt, 'value', '')

        const refs = this.$refs || {}
        const mf = refs.metricsForm
        if (mf && typeof mf.uncheckThresholdToggle === 'function') {
          mf.uncheckThresholdToggle()
        }
        return
      }

      if (key === 'threshold' && idx !== undefined) {
        resetMetricRowField(idx, 'Threshold on metrics')
        return
      }
      if (typeof key === 'string' && key.includes('.')) {
        const path = key.split('.')
        const parent = getByPath(this.filters, path.slice(0, -1))
        const leafKey = path[path.length - 1]
        const target = parent?.[leafKey]
        if (target) {
          setValueEmptyReactive(target)
          return
        }
      }

      switch (key) {
        case 'year': {
          const refs = this.$refs || {}
          const ef = refs.essentials
          if (ef && typeof ef.resetYearInput === 'function') ef.resetYearInput()
          if (!flags.keepYearFilters && this.filters?.essentials) {
            if (this.filters.essentials.startYear) this.$set(this.filters.essentials.startYear, 'value', '')
            if (this.filters.essentials.endYear) this.$set(this.filters.essentials.endYear, 'value', '')
          }
          break
        }

        case 'age': {
          const refs = this.$refs || {}
          const df = refs.demographicsForm
          if (df && typeof df.clearAgeInput === 'function') {
            df.clearAgeInput()
          }

          const g = this.filters?.demographics
          if (g && typeof g === 'object') {
            const maybeKeys = ['age', 'ageFrom', 'ageTo', 'minAge', 'maxAge', 'ageMin', 'ageMax', 'ageRange']
            maybeKeys.forEach(k => {
              const f = g[k]
              if (!f) return
              if (k === 'ageRange' && f.value && typeof f.value === 'object') {
                const nv = { ...f.value }
                if ('from' in nv) nv.from = ''
                if ('to' in nv) nv.to = ''
                if ('min' in nv) nv.min = ''
                if ('max' in nv) nv.max = ''
                this.$set(f, 'value', nv)
              } else {
                setValueEmptyReactive(f, '')
              }
            })

            Object.entries(g).forEach(([fieldKey, fieldObj]) => {
              const isAge =
                fieldKey.toLowerCase().includes('age') ||
                (fieldObj?.key && String(fieldObj.key).toLowerCase().includes('age'))
              if (isAge) setValueEmptyReactive(fieldObj, '')
            })
          }
          break
        }

        case 'socialClass': {
          const refs = this.$refs || {}
          const df = refs.demographicsForm
          if (df && typeof df.clearSocialClass === 'function') df.clearSocialClass()
          if (this.filters && this.filters.demographics && this.filters.demographics.socialClass) {
            setValueEmptyReactive(this.filters.demographics.socialClass, [])
          }
          break
        }

        case 'threshold': {
          const refs = this.$refs || {}
          const mf = refs.metricsForm
          if (mf && typeof mf.uncheckThresholdToggle === 'function') {
            mf.uncheckThresholdToggle()
          }
          const metrics = this.filters && this.filters.metrics
          if (metrics && Array.isArray(metrics.metricsList)) {
            metrics.metricsList.forEach(m => {
              this.$set(m, 'applyThreshold', false)
              if (m.threshold && m.threshold.value) {
                this.$set(m.threshold, 'value', { amount: 10, desc: false, type: '' })
              }
            })
          }
          const mt = metrics && metrics.threshold
          if (mt) this.$set(mt, 'value', '')

          break
        }

        case 'creative': {
          if (this.filters?.fragranceDetails?.creative) {
            this.$set(this.filters.fragranceDetails.creative, 'value', undefined)
          }
          break
        }

        default: {
          Object.values(this.filters || {}).forEach(group => {
            if (!group || typeof group !== 'object') return
            Object.entries(group).forEach(([fieldKey, fieldObj]) => {
              if (fieldKey === key || fieldObj?.key === key) {
                setValueEmptyReactive(fieldObj, '')
              }
            })
          })
          break
        }
      }
    },
    addMetric () {
      this.filters.metrics.metricsList.push({
        applyThreshold: false,
        threshold: {
          label: 'Threshold on metrics',
          key: 'threshold',
          value: { amount: 10, desc: false, type: '' }
        },
        metricType: { label: 'Metric type', key: 'metric_type', value: '' },
        metric: { label: 'Metric', key: 'metric', value: '' },
        aggregation: { label: 'Aggregation', key: 'aggregation', value: '' },
        confidence: { label: 'Confidence', key: 'confidence', value: false }
      })
    },
    removeMetric (index) {
      const metricsList = this.filters.metrics.metricsList
      if (metricsList.length > 1) {
        metricsList.splice(index, 1)
      } else {
        this.$set(this.filters.metrics.metricsList, index, filtersFunctions.getEmptyMetric())
      }
    },
    toggleFiltersCollapse () {
      this.$emit('setCollapse', !this.collapsed)
    },
    setFilterValue (value, valueType) {
      switch (valueType) {
        case 'useConcepts':
          this.filters.metrics[valueType] = value
          break
        case 'rdfType':
          this.filters.metrics[valueType].value = value
          break
        default:
          this.filters.metrics[valueType] = value
      }
    }
  },
  watch: {
    yearsObject: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localYearsObject)) {
          this.localYearsObject = value ? _.cloneDeep(value) : value
        }
      }
    },
    localYearsObject: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.yearsObject)) {
          this.$emit('update:yearsObject', value ? _.cloneDeep(value) : value)
        }
      }
    },
    saveMessage: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localSaveMessage)) {
          this.localSaveMessage = _.cloneDeep(value)
        }
      }
    },
    localSaveMessage: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.saveMessage)) {
          this.$emit('update:saveMessage', _.cloneDeep(value))
        }
      }
    },
    '$route': function () {
      this.$emit('setCollapse', true)
      this.openedPanel = this.$route.name === 'analytics' ? 'Metrics' : 'Essentials'
      if (this.$route.name === 'analytics') {
        this.refreshFilters()
      } else {
        this.filters = _.cloneDeep(filtersFunctions.getInitialFilters())
      }
    }
  },
  beforeMount () {
    this.refreshFilters()
  },
  created () {
    this.isReady = true
    setTimeout(() => {
      this.$emit('setCollapse', true)
      this.isReady = false
    }, 800)
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.search-filters-header {
  height: 160px;
  width: 100%;
  background: transparent linear-gradient(266deg, rgba(115,178,224, 0.73) 0%, rgba(0,39,204, 0.73) 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  border: 1px solid #231A44;
  border-left: 0;
  border-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 34px;
  padding-top: 13px;
  position: relative;

  .header-title {
    width: 500px;
    height: 56px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 45px;
    line-height: 30px;
    font-weight: 900;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: white;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header-subtitle {
    height: 30px;
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0;
    margin-bottom: 56px;
  }

  .filter-tabs-wrapper {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: -1px;
    right: 0;
    z-index: 3;
    width: 100%;
    padding-right: 80px;
    // Matches the Saved Searches drawer transition so the tabs slide out from
    // under it instead of jumping.
    transition: padding-right 0.35s ease-in-out;

    .filters-tab {
      max-width: 240px;
      width: 100%;
      height: 44px;
      color: $dusty-blue;
      border: 1px solid #25232C;
      background-color: $silver;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 20px;
      line-height: 25px;
      letter-spacing: 0;
      cursor: pointer;
      border-left: 0;

      &:first-of-type {
        border-left: 1px solid #25232C;
      }
    }

    .saved-searches-toggle {
      position: absolute;
      width: 80px;
      transition: right 0.35s ease-in-out;
      background-color: #3981FF;
      bottom: 0;
      border-left: 1px solid #25232C;
      border-right: 1px solid #25232C;
    }

    .selected {
      border-bottom: 0;
      background-color: $light-grey !important;
      font-weight: 900;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 80%;
        left: 10%; /*this centers it based on the above width*/
        border-bottom: 2px solid $dusty-blue;
      }
    }
  }
}

.search-filters-card {
  margin-bottom: 0;
  box-shadow: 0 5px 7px #999999;
  background-color: $light-grey;
  border: 0;

  .search-filters-card-body {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 38px 132px;
    transition: padding-right 0.35s ease-in-out;
  }

  .search-filters-actions-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 582px;
    height: 118px;
    align-self: flex-end;
    margin-top: 15px;

    .search-button {
      width: 100%;
      max-width: 230px;
      height: 48px;
      background-color: $blueberry;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 800;
      line-height: 30px;
      letter-spacing: 0;
      border-radius: 4px;
      color: white;
      text-transform: uppercase;

      transition: background-color 0.2s linear;

      &:hover {
        background-color: #9256D9;
      }
    }

    .search-button-alt {
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0;
      width: 100%;
      max-width: 230px;
      height: 48px;
      background-color: #F8F8F8;
      border-radius: 4px;
      color: $button-text;
      text-transform: uppercase;
      transition: all 0.2s linear;
      margin-right: 30px;

      &:hover {
        border-color: #dedede;
        background-color: white;
      }
    }
  }
}

.country-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;

  .country-info {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #525252;
    font-size: 26px;
    font-family: 'Source Sans Pro', sans-serif;
    line-height: 26px;
    font-weight: 900;
  }
}

.filters-header {
  padding: 12px 17px;
  cursor: pointer;
}

.tag-wrapper {
  margin-top: 25px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

.form-container {
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: opacity 0.3s ease-in;
}

.visible {
  height: unset;
  opacity: 1;
}

.visible-ie {
  height: auto;
  opacity: 1;
}

.panel-switches-wrapper {
  padding: 0 0 20px;
  width: 100%;
  font-size: 15px;
  display: flex;
  justify-content: flex-end;
}

.panel-switch {
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c1c4c7;
  transition: color 0.2s linear;
  cursor: pointer;
}

.panel-switch:hover {
  color: #20a8d8
}

.selected {
  color: #20a8d8
}

.panel-icon {
  font-size: 12px;
  margin-right: 3px;
}

.slider-wrapper {
  width: 92%;
  margin: -7px auto 0;
}

.applied-filter {
  border-top: 1px dashed #d1d4d7;
  transition: background-color 0.2s linear;
}

.applied-filter:first-of-type {
  margin-top: 0 !important;
}

.applied-filter:last-of-type {
  border-bottom: 1px dashed #d1d4d7;
  margin-bottom: 10px !important;
}

.remove-applied-filter {
  font-size: 14px;
  color: #d1d4d7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d1d4d7;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  cursor: pointer;
  transition: 0.2s linear;
}

.remove-applied-filter:hover {
  color: black;
  border: 1px solid black;
}

.is-invalid > > > .el-input__inner {
  border-color: #f86c6b !important;
}

.error-message {
  position: absolute;
  top: 45px;
  color: #f86c6b;
  font-size: 12px;
}

.disabled-save {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #6E6E6E !important;
  padding: 1px 8px;
  height: 100%;
}

.success-message {
  position: absolute;
  top: 45px;
  left: 20px;
  color: #2d884d;
  font-size: 12px;
  font-family: 'Open Sans', sans-serif;
}

.remove-applied-metric {
  font-size: 14px;
  color: #d1d4d7;
  position: absolute;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d1d4d7;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  cursor: pointer;
  transition: 0.2s linear;
  top: 2px;
  right: 15px;
}

.remove-applied-metric:hover {
  color: black;
  border: 1px solid black;
}

.warning-text {
  position: absolute;
  top: 15px;
  right: 30px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 800;
  line-height: 26px;
  color: $red-600;
}

.open-filter-button {
  position: absolute;
  bottom: 24px;
  right: 24px;
  font-size: 35px;
  line-height: 35px;
  height: 35px;
  color: $home-card;
  cursor: pointer;
  transition: color 0.2s linear, right 0.35s ease-in-out;

  &:hover {
    color: $navbar-dropdown-text
  }
}

/*
  The Saved Searches drawer is position: fixed and floats over the page, so
  without this the right-most controls - the save-search name field with its
  upload button, and the Search button - end up underneath it. Reserve the
  drawer's width on the right while it is open so everything stays reachable.
  $saved-searches-width must stay in sync with SavedSearches.vue's .opened.
*/
$saved-searches-width: 348px;

.saved-searches-open {
  .search-filters-header .filter-tabs-wrapper {
    padding-right: 80px + $saved-searches-width;
  }

  .search-filters-card .search-filters-card-body {
    padding-right: 132px + $saved-searches-width;
  }

  .open-filter-button {
    right: 24px + $saved-searches-width;
  }
}
</style>

<style lang="scss">
@import "../../assets/scss/variables";

.search-filters-card {
  .search-filters-actions-wrapper {
    .el-input__inner {
      border-right: 0 !important;

    }

    .el-input-group__append {
      color: white !important;
      cursor: pointer;
      padding: 0 !important;
      border: 0 !important;

      div {
        background-color: $active-link;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 1px 8px;
        height: 100%;
      }
    }
  }
}
</style>
